// extracted by mini-css-extract-plugin
module.exports =  {"addToCartBtnContainer":"aAjhWb","addToCartIconTooltip":"dPDwDf","addToCartBtn":"iwJPpl","iconButton":"PAuLBm","dummyTextForLoadingWidth":"KB0hlQ","prefixIcon":"e8zf5b"};